"use client"

import { Rainbow } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `RainbowIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const RainbowIcon = component(Icon)({ as: Rainbow })
